<template>
  <div class="d-flex mt-2" style="flex-direction: column; overflow-y: auto; max-height: 350px">
    <div v-for="(optionals, index) in groupedByOptionals" :key="optionals.id">
      <div>
        <!-- Name der Optionals -->
        <b>{{ optionals.beschreibung }}</b>

        <div
          class="d-flex mt-2 justify-content-between"
          v-for="tagesausflug in groupedTagesausflug(optionals.items)"
          :key="tagesausflug.name"
        >
          <!-- Name des Tagesausflug -->
          <div class="mr-2">
            {{ tagesausflug.name }} ({{ getKuerzel(tagesausflug.name, tagesausflug.beschreibung) }}):
          </div>

          <div class="d-flex">
            <!-- Widgets für die tagesausflüge -->
            <template>
              <div v-for="widget in tagesausflug.widgets" :key="widget.id" class="ml-3">
                <div class="optionals-badge mr-1" :class="istBgColor(widget.item)">
                  <div class="optionals-status">
                    {{
                      widget.item.verfuegbarkeitsStatus == 'Verfuegbar'
                        ? widget.value
                        : widget.item.verfuegbarkeitsStatus == 'NichtVerfuegbar'
                        ? 'N'
                        : 'RQ'
                    }}
                  </div>
                  <!-- Zimmertyp (z.B. "DZ", "EZ", "FAK"), nur wenn vorhanden -->
                  <div v-if="widget.zimmertyp" class="optionals-zimmertyp">
                    {{ widget.zimmertyp }}
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <hr v-if="index < groupedByOptionals.length - 1" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    optionals: {
      type: Array,
      required: true,
    },
    reiseterminId: {
      type: Number,
    },
  },
  computed: {
    groupedOptionals() {
      if (!this.optionals) return [];

      const processStatus = status => {
        // Filter nach Status
        const filtered = this.optionals.filter(o => o.verfuegbarkeitsStatus === status);

        // Gruppiere nach Beschreibung UND ausflugsnamen
        const grouped = filtered.reduce((acc, curr) => {
          const key = `${curr.beschreibung}-${curr.name}`;
          if (!acc[key]) {
            acc[key] = {
              beschreibung: curr.beschreibung,
              verfuegbarkeitsStatus: status,
              name: curr.name,
              zimmertypen: {},
            };
          }
          // Füge Zimmertyp hinzu
          acc[key].zimmertypen[curr.zimmertyp] = curr.einheitenFrei;
          return acc;
        }, {});
        return Object.values(grouped);
      };

      const aufAnfrage = processStatus('AufAnfrage');
      const verfuegbar = processStatus('Verfuegbar');

      // Kombiniere die Ergebnisse und filtere leere Objekte
      return [...aufAnfrage, ...verfuegbar].filter(item => Object.keys(item.zimmertypen).length > 0);
    },

    groupedByOptionals() {
      const groups = this.groupedOptionals.reduce((acc, item) => {
        if (!acc[item.beschreibung]) acc[item.beschreibung] = { beschreibung: item.beschreibung, items: [] };
        acc[item.beschreibung].items.push(item);
        return acc;
      }, {});
      return Object.values(groups);
    },
  },
  methods: {
    groupedTagesausflug(items) {
      const tagesausflugGroups = items.reduce((acc, item) => {
        // wenn das Optional noch nicht im acc ist, dann wird ein neues Hotel Objekt erstellt
        if (!acc[item.name]) {
          acc[item.name] = {
            name: item.name,
            beschreibung: item.beschreibung,
            // ein array von Widgets
            widgets: [],
          };
        }

        // Es werden hier die Widgets erstellt und in das widgets-Array gepusht
        Object.entries(item.zimmertypen).forEach(([zimmertyp, value]) => {
          acc[item.name].widgets.push({
            id: `${item.id}-${zimmertyp}`,
            zimmertyp, // "FAK" oder "CHI" etc
            value, // die Anzahl der Zimmer
            item, // referenz auf das ursprüngliche Item
          });
        });
        return acc;
      }, {});
      return Object.values(tagesausflugGroups);
    },

    // Bildet den Verfügbarkeitsstatus auf die Kachel-Farbklasse ab (grün verfügbar, rot nicht verfügbar, gelb auf Anfrage)
    istBgColor(optionals) {
      return optionals.verfuegbarkeitsStatus == 'Verfuegbar'
        ? 'green'
        : optionals.verfuegbarkeitsStatus == 'NichtVerfuegbar'
        ? 'red'
        : 'yellow';
    },
    getKuerzel(name, beschreibung) {
      if (this.optionals) {
        const kuerzel = this.optionals.find(
          item => item.name === name && item.beschreibung === beschreibung
        )?.kuerzel;
        return kuerzel;
      } else return '';
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/sass/components/mixins/_kachel-badge.scss';

.optionals-badge {
  @include kachel-badge-base;
  flex-direction: column;
  padding: 4px;
  min-width: 33px;

  @include kachel-badge-colors;
}
.optionals-status {
  font-weight: 700;
  font-size: 12px;
  line-height: 12px;
}
.optionals-zimmertyp {
  font-weight: 400;
  font-size: 9px;
  line-height: 11px;
}
.tooltip {
  opacity: 1 !important;
}
</style>
<style>
.custom-tooltip-optionals-widget > .tooltip-inner {
  max-width: none;
}
</style>
